import { render, staticRenderFns } from "./NoteCredits.vue?vue&type=template&id=993291a6&scoped=true"
import script from "./NoteCredits.vue?vue&type=script&lang=js"
export * from "./NoteCredits.vue?vue&type=script&lang=js"
import style0 from "./NoteCredits.vue?vue&type=style&index=0&id=993291a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993291a6",
  null
  
)

export default component.exports